import { Type } from '@sinclair/typebox'

export const NullableNumber = () => {
  return Type.Union([Type.Number(), Type.Null()])
}

export const NullableOptionalNumber = () => {
  return Type.Optional(NullableNumber())
}

export const OptionalNullableCleanString = Type.Optional(
  Type.Union([
    Type.Null(),
    Type.String({format: 'clean-string'})
  ])
)
